// removed by extract-text-webpack-plugin
module.exports = {"caption":"caption___1zhKh","selectWrapper":"selectWrapper___3GHxG","select":"select___34vrX","open":"open___3JygX","month":"month___2knf- select___34vrX","year":"year___1ABPR select___34vrX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Inputs/DayPicker/Caption/index.scss
// module id = 88
// module chunks = 0